import { render, staticRenderFns } from "./top-material-relaunch.vue?vue&type=template&id=0136d4e5&scoped=true"
import script from "./top-material-relaunch.vue?vue&type=script&setup=true&lang=js"
export * from "./top-material-relaunch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./top-material-relaunch.vue?vue&type=style&index=0&id=0136d4e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0136d4e5",
  null
  
)

export default component.exports